import { render, staticRenderFns } from "./TestResults.vue?vue&type=template&id=5b89ca54&scoped=true"
import script from "./TestResults.vue?vue&type=script&lang=js"
export * from "./TestResults.vue?vue&type=script&lang=js"
import style0 from "./TestResults.vue?vue&type=style&index=0&id=5b89ca54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b89ca54",
  null
  
)

export default component.exports